import { RoundResultsListTable } from '~/pages/round-results/components/round-results-list-table';
import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useDeleteDivisionMutation } from '../mutations';
import { useDivisionDetailQuery } from '../queries';
import { divisionIdParamSchema } from '~/schemas';
import { useParams } from '~/hooks/useParams';
import { useDialog } from '~/hooks/useDialog';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { insertOnCondition } from '~/utils/array';
import { useAuthentication } from '~/hooks/useAuthentication';

export function Page() {
  const { divisionId } = useParams(divisionIdParamSchema.parse);
  const { data } = useDivisionDetailQuery(divisionId);
  const { can } = useAuthentication();

  const mutation = useDeleteDivisionMutation();
  const navigate = useNavigate();
  const dialog = useDialog();

  async function handleConfirm() {
    await toast.promise(mutation.mutateAsync(divisionId), {
      success: 'Divisionen har tagits bort',
      pending: 'Tar bort division...',
    });

    navigate(-1);
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={`${data.name} - ${data.series.name}`} />

        <PageLayout.Context
          items={[
            ...insertOnCondition(
              <ContextMenu.Item label="Redigera division" to={`edit`} key="edit" />,
              can('edit-division')
            ),
            ...insertOnCondition(
              <ContextMenu.Item label="Ta bort" onClick={dialog.open} key="delete" danger />,
              can('delete-division')
            ),
          ]}
        />
      </PageLayout.Header>
      <PageLayout.Section>
        <RoundResultsListTable rounds={data.rounds} teams={data.teams} />
      </PageLayout.Section>

      <ConfirmDialog onConfirm={handleConfirm} isLoading={mutation.isPending} {...dialog} />
    </Fragment>
  );
}
